export const environment = {
  production: true,
  BASE_URL: 'https://api.kff-ks.com/api/v1/'
};
